import { Component, Injector, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { jkBaseForm, jkGlb, TitlebarComponent, MaterialModule, JackBaseComponentModule } from 'jk-service';
import { MdqSettingsComponent } from '../components/md-query/mdq-settings.component';

@Component({
  standalone: true,
  selector: 'app-utyjb54',
  templateUrl: './utyjb54.component.html',
  styleUrls: ['./utyjb54.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule, JackBaseComponentModule, TitlebarComponent, MdqSettingsComponent],
})
export class Utyjb54Component extends jkBaseForm implements OnInit {
  override _programId = 'utyjb54';
  get backendUrl(): string {
    return jkGlb.config?.mdQueryUrl || this._backendUrl;
  }
  set backendUrl(value: string) {
    this._backendUrl = value;
  }
  private _backendUrl: string = '';
  mdQueryToken = signal('');

  constructor(injector: Injector = inject(Injector)) {
    super(injector);
    if (jkGlb.config?.mdQueryUrl) {
      this.backendUrl = jkGlb.config.mdQueryUrl;
    }
    if (jkGlb.config?.mdQueryToken) {
      this.mdQueryToken.set(jkGlb.config.mdQueryToken);
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    if (!this.backendUrl && jkGlb.config?.mdQueryUrl) {
      this.backendUrl = jkGlb.config.mdQueryUrl;
    }
  }

  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    this.checkAllInit(this);
    if (!this.backendUrl && jkGlb.config?.mdQueryUrl) {
      this.backendUrl = jkGlb.config.mdQueryUrl;
    }
  }
}

